import { Toggle } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { MedicalProfileTabFormController, SectionRowViewModel } from '../../tab/MedicalProfileTab.types';
import { createShowOnVisitFieldName } from '../../tab/MedicalProfileTab.utils';

type ShowOnVisitToggleFieldProps = Pick<MedicalProfileTabFormController, 'register'> & {
   readonly templateCode: string;
   readonly row: SectionRowViewModel;
   readonly disabled: boolean;
};

export const ShowOnVisitToggleField = (props: ShowOnVisitToggleFieldProps): JSX.Element => (
   <Toggle
      testId={`showOnVisit-${props.row.sectionId}`}
      label={appointmentsTranslationKeys.medicalProfile.showOnVisit.label}
      controller={props.register(createShowOnVisitFieldName(props.templateCode, props.row.sectionId))}
      defaultValue={props.row.initialShowOnVisit}
      disabled={props.disabled}
      horizontal
   />
);
